<template>
  <div class="container">
    <div v-if="isLoading" class="loading">&nbsp;</div>
    <div class="">
      <h1>Feedback Data Upload</h1>
      File Types Allowed:<br />
      <ul>
        <li>.csv (comma delimited)</li>
        <li>.txt (comma delimeted)</li>
        <li>.xls</li>
        <li>.xlsx</li>
      </ul>
      <br />
      Column names must be named the following::<br />
      <ul>
        <li>
          'feedback' - the open text comments (this is the only required data)
        </li>
        <li>
          'created_date' - the date you received the feedback. Formats
          acceptable: 2019-01-01 15:00:00 (optional)
        </li>
        <li>
          'feedback_rating' - overall rating or NPS score from customer. Formats
          acceptable: (1-10) or (promoter, detractor, passive) (optional)
        </li>
        <li>
          'referral_rating' - refer a friend rating. Formats acceptable: (1-10)
          (optional)
        </li>
      </ul>
      <br />
      <label
        ><h3>Please select a file:</h3>
        <input
          id="file"
          ref="file"
          type="file"
          class="input-file"
          @change="handleFileUpload()"
        />
      </label>
      <br /><br />
      <button class="button button-200" @click="submitFile()">
        Upload File
      </button>
    </div>
    <div v-if="isLoadingFileSuccessful" class="">
      <br />
      <h3 style="color: red;">File Successfully Uploaded</h3>
    </div>
    <br />
    <div class="">
      <div class="file-list">
        <div class="half">
          <h2>File Name</h2>
        </div>
        <div class="quarter">
          <h2>Date Uploaded</h2>
        </div>
        <div class="quarter">
          <h2>Date Imported</h2>
        </div>
      </div>
      <span v-if="!feedbackFiles.length">No Files Uploaded!</span>
      <div v-for="f in feedbackFiles" :key="f.id" class="file-list">
        <div class="half">
          {{ f.filename }}
        </div>
        <div class="quarter">
          {{ formatDate(f.created_date) }}
        </div>
        <div class="quarter">
          {{ f.imported_date ? f.imported_date : "Awaiting Import" }}<br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/index";
const apiServiceFeedbackFile = new api.APIServiceFeedbackFile();

export default {
  /*
    Defines the data used by the component
  */
  data() {
    return {
      file: "",
      feedbackFiles: [],
      isLoading: false,
      isLoadingFileSuccessful: false,
      propertyID: this.$route.params.id
    };
  },
  computed: {
    // feedbackFiles () {
    //   return this.$store.getters.feedbackFiles;
    // },
    // isLoading () {
    //   return this.$store.getters.isLoadingFile;
    // },
    // isLoadingFileSuccessful () {
    //   return this.$store.getters.isLoadingFileSuccessful;
    // }
  },
  created() {
    this.getFeedbackFiles();
    // this.$store.commit('setIsLoadingFile', false);
    // this.$store.commit('setIsLoadingFileSuccessful', false);
    // var input = this.$refs.file;
    // input.type = 'text';
    // // input.type = 'file';
  },
  methods: {
    getFeedbackFiles() {
      apiServiceFeedbackFile.getFeedbackFiles(this.propertyID).then(data => {
        if (data) {
          console.log(data.data);
          this.feedbackFiles = data.data;
        }
      });
    },
    createFeedbackFileUpload() {
      apiServiceFeedbackFile
        .createFeedbackFileUpload(this.propertyID, this.file)
        .then(data => {
          this.isLoadingFileSuccessful = true;
          this.isLoading = false;
          this.getFeedbackFiles();
        })
        .catch(error => {
          console.log(error);
        });
    },
    /*
      Submits the file to the server
    */
    submitFile() {
      if (this.file) {
        this.isLoadingFileSuccessful = false;
        this.isLoading = true;
        this.createFeedbackFileUpload();
        // this.$store.dispatch('createFeedbackFileUpload', {
        //   data1: this.$route.params.id,
        //   data2: this.file
        // });
      }
    },
    /*
      Handles a change on the file upload
    */
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    formatDate(date) {
      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      let days = [
        "Monday",
        "Tuesday",
        "Wendesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ];

      let d = new Date(date);

      return (
        days[d.getDay()] +
        ", " +
        d.getDate() +
        " " +
        months[d.getMonth()] +
        " " +
        d.getFullYear()
      );
    }
  }
};
</script>
<style scoped>
.input-file {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 3px;
  width: 550px;
}
.file-list div.half {
  lost-column: 2/4;
}
.file-list div.quarter {
  lost-column: 1/4;
}
ul {
  margin-left: 20px;
}
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: "";
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1500ms infinite linear;
  -moz-animation: spinner 1500ms infinite linear;
  -ms-animation: spinner 1500ms infinite linear;
  -o-animation: spinner 1500ms infinite linear;
  animation: spinner 1500ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
